// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__oK8uB","cross":"styles_cross__xqGjl","content":"styles_content__9roX5","title":"styles_title__pdPM8","subTitle":"styles_subTitle__9md62"};